import { Attributes, Misc, Model, ModelBase, Validation } from '@singularsystems/neo-core';

export default class InvestorInvestmentClientApproval extends ModelBase {
    static typeName = "InvestorInvestmentClientApproval";

    constructor() {
        super();
        this.makeObservable();
    }

    public investorInvestmentClientApprovalId: number = 0;

    @Attributes.Nullable()
    public investorInvestmentApprovalId: number | null = null;

    @Attributes.Nullable()
    public investorInvestmentNoticeRequestId: number | null = null;

    @Attributes.ChildObject(Model.UserEvent, true)
    public authorised: Model.UserEvent = Model.UserEvent.None();

    @Attributes.NoTracking(Misc.SerialiseType.FullOnly)
    public authorisedByName: string = "";

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<InvestorInvestmentClientApproval>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew) {
            return "New investor investment client approval";
        } else {
            return "Investor Investment Client Approval";
        }
    }
}